<template>
  <BaseGridView
    endpoint="v1/CustomDimensionSetting/GetData"
    :pageTitle="$t('Custom Dimension Settings')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
    :templateDef="templateDef"
  >
    <template #dimensionSetting_isActive="{ rowData }">
      <span
        :class="rowData.value ? 'badge badge-success' : 'badge badge-danger'"
      >
        {{ rowData.value ? "Active" : "Inactive" }}
      </span>
    </template>
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: ["company.Name", "name", "ordinal"],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const templateDef: TemplateDef = {
  prefix: "dimensionSetting",
  columnNames: ["isActive"],
};

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
    },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "dimensionSetting_isActive",
    },
    { field: "name", headerText: instance?.$t("name") },
    { field: "ordinal", headerText: instance?.$t("ordinal") },
  ];
};
</script>
